import conexao from './userlogin'
import { SetupEnvioLocal } from './atualizalocal';

let online = navigator.onLine;
let jaDefinido = false;

export async function IsOnline() {
  return online;
}

export function SetupIsOnline() {
  if (!jaDefinido) {
    window.addEventListener('offline', () => {
      console.log('Atualmente Offline');
      online = false;
    });
    window.addEventListener('online', () => {
      console.log('Atualmente Online');
      SetupEnvioLocal();
      conexao();
      online = true;
    });
    jaDefinido = true;
  }
}
